import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BAUP } from '../core/models/File';
import { Observable, tap } from 'rxjs';
import { FileParentEnum } from '../core/models/FileParentEnum';
import { HttpEvent, HttpEventType } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private apiService: ApiService) {}

  addFiles(files: FormData, parentId: number, parentType: FileParentEnum, contractId: number, inventoryItemId?: number): Observable<HttpEvent<File[]>> {
    let url = `/api/File/Files?parentId=${parentId}&parentType=${parentType}&contractId=${contractId}`;
    
    // Si se proporciona inventoryItemId, agregarlo a la URL para asociación específica
    if (inventoryItemId !== undefined && inventoryItemId !== null && inventoryItemId > 0) {
      url += `&inventoryItemId=${inventoryItemId}`;
      console.log(`🔗 Asociando archivos al item de inventario ID: ${inventoryItemId}`);
    }
    
    return this.apiService.formDataArrayUpload(url, files).pipe(
      tap(event => {
        if (event.type === HttpEventType.UploadProgress) {
          console.log(`Progreso de subida: ${Math.round((event.loaded / event.total) * 100)}%`);
        }
      })
    );
  }

  // Claim Files (usa apiUrl)
  addClaimFiles(files: FormData, claimId: number, contractId: number): Observable<HttpEvent<File[]>> {
    const url = `/api/File/ClaimFiles?parentId=${claimId}&parentType=${FileParentEnum.CLAIM}&contractId=${contractId}`;
    return this.apiService.formDataArrayUpload(url, files).pipe(
      tap(event => {
        if (event.type === HttpEventType.UploadProgress) {
          console.log(`Progreso de subida (claim): ${Math.round((event.loaded / event.total) * 100)}%`);
        }
      })
    );
  }

  getClaimFiles(claimId: number): Observable<BAUP.File[]> {
    const url = `/api/File/ClaimFiles?parentId=${claimId}&parentType=${FileParentEnum.CLAIM}`;
    return this.apiService.get(url);
  }

  deleteClaimFile(claimId: number, fileId: number): Observable<any> {
    const url = `/api/File/ClaimFiles?parentId=${claimId}&parentType=${FileParentEnum.CLAIM}&fileId=${fileId}`;
    return this.apiService.delete(url);
  }

  // Nuevo método específico para archivos de inventario
  addInventoryFiles(files: FormData, contractId: number, inventoryItemId: number): Observable<HttpEvent<File[]>> {
    // Usar el mismo formato que el endpoint original /api/File/Files
    const url = `/api/File/InventoryFiles?parentId=${contractId}&parentType=5&contractId=${contractId}&inventoryItemId=${inventoryItemId}`;
    console.log(`🔗 Subiendo archivos de inventario - Contrato: ${contractId}, Item: ${inventoryItemId}`);
    
    return this.apiService.formDataArrayUpload(url, files).pipe(
      tap(event => {
        if (event.type === HttpEventType.UploadProgress) {
          console.log(`Progreso de subida: ${Math.round((event.loaded / event.total) * 100)}%`);
        }
      })
    );
  }

  addFilesCash(files: FormData, parentId: number, parentType: FileParentEnum, cashFlowId : number): Observable<HttpEvent<File[]>> {
    return this.apiService.formDataArrayUpload(`/api/File/Files/Cash?parentId=${parentId}&parentType=${parentType}&cashFlowId=${cashFlowId}`, files).pipe(
      tap(event => {
        if (event.type === HttpEventType.UploadProgress) {
          console.log(`Progreso de subida: ${Math.round((event.loaded / event.total) * 100)}%`);
        }
      })
    );
  }
  

  deleteFiles(files: BAUP.File[]) {
    return this.apiService.deleteMany('/api/File/Files', files);
  }

  getFilesByParent(parentId: number, parentType: FileParentEnum): Observable<BAUP.File[]> {
    // Para archivos de contrato, usar el endpoint específico
    if (parentType === FileParentEnum.CONTRACT) {
      return this.apiService.get(`/api/Contract/${parentId}/Files/`);
    }
    // Para otros tipos, usar el endpoint genérico (si existe)
    return this.apiService.get(`/api/File/Files?parentId=${parentId}&parentType=${parentType}`);
  }

  // Método específico para obtener archivos de inventario
  getInventoryFiles(contractId: number, inventoryItemId?: number): Observable<BAUP.File[]> {
    if (inventoryItemId) {
      // Obtener archivos de un item específico
      return this.apiService.get(`/api/File/InventoryFiles?contractId=${contractId}&inventoryItemId=${inventoryItemId}`);
    } else {
      // Obtener todos los archivos de inventario del contrato
      return this.apiService.get(`/api/File/InventoryFiles?contractId=${contractId}`);
    }
  }
}
